/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import './flexible_transfer_step';
import '../../../common/currency';
import '../userjourney/user_journey_signal';
import '../transfer_common/transfer_native_flow';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "common": {
            "nested": {
              "flexible_transfer": {
                "nested": {
                  "FlexibleTransferRequest": {
                    "fields": {
                      "context": {
                        "type": "bytes",
                        "id": 1,
                        "rule": "optional"
                      },
                      "variant": {
                        "type": ".squareup.bbfrontend.common.flexible_transfer.FlexibleTransferRequest.Variant",
                        "id": 2,
                        "rule": "optional"
                      },
                      "clientCapableSteps": {
                        "type": ".squareup.bbfrontend.common.flexible_transfer.FlexibleTransferRequest.ClientCapableStep",
                        "id": 3,
                        "rule": "repeated"
                      },
                      "clientCapableFlows": {
                        "type": ".squareup.bbfrontend.common.flexible_transfer.TransferClientCapableFlow",
                        "id": 4,
                        "rule": "repeated"
                      },
                      "stepSubmissionData": {
                        "type": ".squareup.bbfrontend.common.flexible_transfer.FlexibleTransferRequest.TransferStepSubmissionData",
                        "id": 5,
                        "rule": "optional"
                      },
                      "unitToken": {
                        "type": "string",
                        "id": 6,
                        "rule": "optional"
                      },
                      "accountId": {
                        "type": "string",
                        "id": 7,
                        "rule": "optional"
                      },
                      "accountName": {
                        "type": "string",
                        "id": 8,
                        "rule": "optional"
                      },
                      "clientSupportsNativeFlowAction": {
                        "type": "bool",
                        "id": 9,
                        "rule": "optional"
                      },
                      "bannerCapability": {
                        "type": ".squareup.bbfrontend.common.flexible_transfer.FlexibleTransferRequest.FlexibleTransferBannerCapability",
                        "id": 10,
                        "rule": "optional"
                      },
                      "clientCapableActions": {
                        "type": ".squareup.bbfrontend.common.flexible_transfer.FlexibleTransferRequest.ClientCapableAction",
                        "id": 11,
                        "rule": "repeated"
                      },
                      "stepIdsToSkip": {
                        "type": "string",
                        "id": 12,
                        "rule": "repeated"
                      }
                    },
                    "nested": {
                      "ClientCapableStep": {
                        "values": {
                          "DO_NOT_USE_CLIENT_CAPABLE_STEP": 0,
                          "TRANSFER_OPTIONS": 1,
                          "TRANSFER_AMOUNT": 2,
                          "TRANSFER_CONFIRMATION": 3,
                          "TRANSFER_RESULT": 4,
                          "TRANSFER_OPTIONS_WITH_FOOTER_TEXT_LINK": 5,
                          "TRANSFER_AMOUNT_WITH_SECONDARY_HEADER": 6,
                          "TRANSFER_RESULT_WITH_RICH_TEXT_DESCRIPTION": 7,
                          "TRANSFER_OPTIONS_WITH_INLINE_STATUS": 8,
                          "TRANSFERS_PRIMER": 9,
                          "TRANSFER_CONFIRMATION_SECTIONED_WITH_ROW_INFO_BOX": 10
                        }
                      },
                      "ClientCapableAction": {
                        "values": {
                          "DO_NOT_USE_CLIENT_CAPABLE_ACTION": 0,
                          "FINISH_AND_REFRESH": 1
                        }
                      },
                      "Variant": {
                        "values": {
                          "DO_NOT_USE_VARIANT": 0,
                          "CHECKING_PAY_IN": 1,
                          "CHECKING_PAY_OUT": 2,
                          "SAVINGS_PAY_OUT": 3,
                          "MANUAL_STORED_BALANCE_OUT": 4,
                          "AUTOMATIC_BALANCE_OUT": 5,
                          "STORED_BALANCE_NON_SAVINGS_OUT": 6,
                          "STORED_BALANCE_NON_SAVINGS_INSTANT_OUT": 7,
                          "ADD_MONEY": 8,
                          "NON_SAVINGS_INSTANT_TRANSFER_FULL_BALANCE": 9,
                          "PAY": 10
                        }
                      },
                      "TransferStepSubmissionData": {
                        "fields": {
                          "stepIdentifier": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "amount": {
                            "type": ".squareup.bbfrontend.common.flexible_transfer.FlexibleTransferRequest.TransferStepSubmissionData.AmountSubmission",
                            "id": 2
                          },
                          "selectedIdentifier": {
                            "type": "string",
                            "id": 3
                          }
                        },
                        "nested": {
                          "AmountSubmission": {
                            "fields": {
                              "amount": {
                                "type": ".squareup.common.Money",
                                "id": 1,
                                "rule": "optional"
                              },
                              "calculatedFee": {
                                "type": ".squareup.common.Money",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          },
                          "submission": {
                            "oneof": ["amount", "selectedIdentifier"]
                          }
                        }
                      },
                      "FlexibleTransferBannerCapability": {
                        "fields": {
                          "bannerClientCapableSteps": {
                            "type": ".squareup.bbfrontend.common.flexible_transfer.FlexibleTransferRequest.ClientCapableStep",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "bannerCapableActionTypes": {
                            "type": ".squareup.bbfrontend.common.flexible_transfer.FlexibleTransferRequest.FlexibleTransferBannerCapability.FlexibleTransferBannerActionType",
                            "id": 2,
                            "rule": "repeated"
                          }
                        },
                        "nested": {
                          "FlexibleTransferBannerActionType": {
                            "values": {
                              "DO_NOT_USE_FLEXIBLE_TRANSFER_BANNER_ACTION_TYPE": 0,
                              "FLEXIBLE_TRANSFER_BANNER_ACTION_TYPE_WEB": 1
                            }
                          }
                        }
                      }
                    }
                  },
                  "FlexibleTransferResponse": {
                    "fields": {
                      "context": {
                        "type": "bytes",
                        "id": 1,
                        "rule": "optional"
                      },
                      "userJourneySignal": {
                        "type": ".squareup.bbfrontend.common.userjourney.UserJourneySignal",
                        "id": 6,
                        "rule": "optional"
                      },
                      "step": {
                        "type": ".squareup.bbfrontend.common.flexible_transfer.TransferStep",
                        "id": 2
                      },
                      "clientFlow": {
                        "type": ".squareup.bbfrontend.common.flexible_transfer.TransferClientCapableFlow",
                        "id": 3
                      },
                      "submissionError": {
                        "type": "string",
                        "id": 4
                      },
                      "nativeFlow": {
                        "type": ".squareup.bbfrontend.common.transfer_common.TransferNativeFlow",
                        "id": 5
                      }
                    },
                    "nested": {
                      "result": {
                        "oneof": ["step", "clientFlow", "submissionError", "nativeFlow"]
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.flexible_transfer?.nested?.FlexibleTransferRequest && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.flexible_transfer?.nested?.FlexibleTransferRequest?.nested?.ClientCapableStep && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.flexible_transfer?.nested?.FlexibleTransferRequest?.nested?.ClientCapableAction && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.flexible_transfer?.nested?.FlexibleTransferRequest?.nested?.Variant && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.flexible_transfer?.nested?.FlexibleTransferRequest?.nested?.TransferStepSubmissionData && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.flexible_transfer?.nested?.FlexibleTransferRequest?.nested?.TransferStepSubmissionData?.nested?.AmountSubmission && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.flexible_transfer?.nested?.FlexibleTransferRequest?.nested?.FlexibleTransferBannerCapability && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.flexible_transfer?.nested?.FlexibleTransferRequest?.nested?.FlexibleTransferBannerCapability?.nested?.FlexibleTransferBannerActionType && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.flexible_transfer?.nested?.FlexibleTransferResponse) {
  $root.addJSON(jsonData);
}

/**
 * Request/response
 *
 * SOURCE FlexibleTransferRequest @ squareup/bbfrontend/common/flexible_transfer/flexible_transfer_request_response.proto at 18:1
 */
export const FlexibleTransferRequest = $root.lookupType('squareup.bbfrontend.common.flexible_transfer.FlexibleTransferRequest');
fixType(FlexibleTransferRequest, {
  variant: {
    required: true
  }
});
Builder.createAndAttachToType(FlexibleTransferRequest);
/**
 * SOURCE ClientCapableStep @ squareup/bbfrontend/common/flexible_transfer/flexible_transfer_request_response.proto at 19:3
 */
FlexibleTransferRequest.ClientCapableStep = $root.lookupEnum('squareup.bbfrontend.common.flexible_transfer.FlexibleTransferRequest.ClientCapableStep').values;
/**
 * SOURCE ClientCapableAction @ squareup/bbfrontend/common/flexible_transfer/flexible_transfer_request_response.proto at 46:3
 */
FlexibleTransferRequest.ClientCapableAction = $root.lookupEnum('squareup.bbfrontend.common.flexible_transfer.FlexibleTransferRequest.ClientCapableAction').values;
/**
 * SOURCE Variant @ squareup/bbfrontend/common/flexible_transfer/flexible_transfer_request_response.proto at 52:3
 */
FlexibleTransferRequest.Variant = $root.lookupEnum('squareup.bbfrontend.common.flexible_transfer.FlexibleTransferRequest.Variant').values;
/**
 * SOURCE TransferStepSubmissionData @ squareup/bbfrontend/common/flexible_transfer/flexible_transfer_request_response.proto at 77:3
 */
FlexibleTransferRequest.TransferStepSubmissionData = $root.lookupType('squareup.bbfrontend.common.flexible_transfer.FlexibleTransferRequest.TransferStepSubmissionData');
fixType(FlexibleTransferRequest.TransferStepSubmissionData, {
  stepIdentifier: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(FlexibleTransferRequest.TransferStepSubmissionData);
/**
 * SOURCE AmountSubmission @ squareup/bbfrontend/common/flexible_transfer/flexible_transfer_request_response.proto at 79:5
 */
FlexibleTransferRequest.TransferStepSubmissionData.AmountSubmission = $root.lookupType('squareup.bbfrontend.common.flexible_transfer.FlexibleTransferRequest.TransferStepSubmissionData.AmountSubmission');
fixType(FlexibleTransferRequest.TransferStepSubmissionData.AmountSubmission, {
  amount: {
    required: true
  }
});
Builder.createAndAttachToType(FlexibleTransferRequest.TransferStepSubmissionData.AmountSubmission);
/**
 * SOURCE FlexibleTransferBannerCapability @ squareup/bbfrontend/common/flexible_transfer/flexible_transfer_request_response.proto at 96:3
 */
FlexibleTransferRequest.FlexibleTransferBannerCapability = $root.lookupType('squareup.bbfrontend.common.flexible_transfer.FlexibleTransferRequest.FlexibleTransferBannerCapability');
fixType(FlexibleTransferRequest.FlexibleTransferBannerCapability);
Builder.createAndAttachToType(FlexibleTransferRequest.FlexibleTransferBannerCapability);
/**
 * The action type of the banner. May support deep linking or other client flows in the future.
 *
 * SOURCE FlexibleTransferBannerActionType @ squareup/bbfrontend/common/flexible_transfer/flexible_transfer_request_response.proto at 98:5
 */
FlexibleTransferRequest.FlexibleTransferBannerCapability.FlexibleTransferBannerActionType = $root.lookupEnum('squareup.bbfrontend.common.flexible_transfer.FlexibleTransferRequest.FlexibleTransferBannerCapability.FlexibleTransferBannerActionType').values;
/**
 * SOURCE FlexibleTransferResponse @ squareup/bbfrontend/common/flexible_transfer/flexible_transfer_request_response.proto at 151:1
 */
export const FlexibleTransferResponse = $root.lookupType('squareup.bbfrontend.common.flexible_transfer.FlexibleTransferResponse');
fixType(FlexibleTransferResponse);
Builder.createAndAttachToType(FlexibleTransferResponse);